module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/roles/roles.component.css
// module id = ./src/app/ultilities/roles/roles.component.css
// module chunks = main